// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ISBn","title":"Info_title__2NdJG","links":"Info_links__1_VlC","link":"Info_link__3bJZQ","logo":"Info_logo__1B5oc"};